import { t } from '@lingui/core/macro'

import { Box } from '@jotta/ui/Box'
import { redirectToLogin } from '@jotta/utils/auth'

import type { TextareaStore } from './TextArea'
import { Textarea } from './TextArea'

const LoginOverlay: React.FC<{ notLoginUser: boolean }> = ({
  notLoginUser,
}) => {
  if (!notLoginUser) {
    return null
  }
  return (
    <Box
      sx={{
        position: 'absolute',
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        cursor: 'pointer',
      }}
      onClick={() => redirectToLogin()}
    />
  )
}

export const CommentInput: React.FC<{
  onSubmit?: (text: string) => void
  textStore?: TextareaStore
  notLoginUser?: boolean
  darkMode?: boolean
}> = ({ onSubmit, textStore, notLoginUser = false, darkMode = false }) => {
  const placeholder = notLoginUser ? t`Sign in to comment` : t`Say something`
  return (
    <Box
      sx={{
        boxShadow: 'rgb(0 0 0 / 30%) 0px 0px 5px',
        padding: 3,
        flex: '0 0 auto',
        position: 'relative',
        backgroundColor: darkMode ? '#212121' : 'white', // TODO: Fix hardcoded color
      }}
    >
      <Textarea
        sx={{
          resize: 'none',
          overflow: 'hidden',
          border: 0,
          fontSize: 2,
        }}
        placeholder={placeholder}
        onSubmit={onSubmit}
        textStore={textStore}
        disabled={notLoginUser}
        focusOnMount
      />
      <LoginOverlay notLoginUser={notLoginUser} />
    </Box>
  )
}
